import { getLinkToServerElement } from "../helpers/api.helper";

export const firmwareData = {
  nineteenth: {
    headingA: "Прошивки для разгона 19й серии BITMAIN от разработчика VNISH",
    headingB: "*NO SD SLOT  (Beagle Bone версия)",
    headingC:
      "*Программа для создания карты памяти (можно использовать любую программу для создания образов)",
    instructionHeading: "ИНСТРУКЦИЯ",
    statisticKey: "nineteenth_v2",
    firmwareA: [
      {
        title: "Antminer S19 95 TH",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19_95_TH",
      },
      {
        title: "Antminer S19 88 TH",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19-88-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19-88-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19_88_TH",
      },
      {
        title: "Antminer S19 A",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19a-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19a-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19_A",
      },
      {
        title: "Antminer S19 PRO",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19pro-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19pro-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19_PRO",
      },
      {
        title: "Antminer S19i",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19i-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19i-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19i",
      },
      {
        title: "Antminer S19J",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19j-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19j-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19J",
      },
      {
        title: "Antminer S19J PRO",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19jpro-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19jpro-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19J_PRO",
      },
      {
        title: "Antminer S19+",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19plus-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19plus-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19_plus",
      },
      {
        title: "Antminer T19",
        links: {
          sd: getLinkToServerElement(
            "antminer-t19-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-t19-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_T19",
      },
    ],
    firmwareB: [
      {
        title: "Antminer S19J",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19j-bb-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19j-bb-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19J_NO_SD",
      },
      {
        title: "Antminer S19J PRO",
        links: {
          sd: getLinkToServerElement(
            "antminer-s19jpro-a-bb-official-v1.1.12-sd.img.gz",
            "firmware"
          ),
          update: getLinkToServerElement(
            "antminer-s19jpro-a-bb-official-v1.1.12-update.tar.gz",
            "firmware"
          ),
        },
        statistic: "nineteenth_v2_Antminer_S19J_PRO_NO_SD",
      },
    ],
    firmwareC: [
      {
        title: "ETCHER",
        link: "https://etcher.balena.io",
      },
    ],
    instruction: [
      'Если на передней панели вашего асика есть разъем для карты памяти, используйте обычную версию, если его нет (он есть но на самой контрольке) используйте версию "NO SD SLOT".',
      "Прошивка работает только с модели указанными рядом с кнопками СКАЧАТЬ. Если вы поставите не ту прошивку - асик просто не будет работать. Достанете карту памяти с прошивкой - и он заработает на своей родной. ",
      "Для установки прошивки используйте SD-карту (не более 16 ГБ, FAT 32).",
      'Загрузите файл с образом прошивки для соответствующего асика нажав кнопку "Скачать SD образ", а также программу для создания образов. Распакуйте архив, достаньте из него образ прошивки, а далее с помощью программы для создания образов установите ее на карту памяти.',
      "Вставьте SD-карту с прошивкой VNISH и включите майнер. ГОТОВО! Вписываете ваши настройки пула и маните. Если вы вытащите SD-карту - вернется прошивка BITMAIN.",
      'Если у вас уже стоит прошивка VNISH - можете просто обновить ее нажав кнопку "Скачать обновление" рядом с соответствующей моделью.',
    ],
  },
  hiveon: {
    heading: "Прошивки для разгона от HIVE ON",
    statisticKey: "hiveon",
    firmware: [
      {
        title: "Antminer L7 (все версии)",
        link: "firmware/SD-Antminer-L7-xilinx-Hiveon-1.00@230522-core_1.0.10-alfacore13.zip",
        statistic: "hiveon_Antminer_L7",
      },
      {
        title: "Antminer S19",
        link: "firmware/SD_Antminer_S19_xilinx_19_Hiveon_1_00@220716_MSK_1_3_1_alfacore.zip",
        statistic: "hiveon_Antminer_S19",
      },
      {
        title: "Antminer T19",
        link: "firmware/SD_Antminer_T19_xilinx_19_Hiveon_1_00@220716_MSK_1_3_1_alfacore.zip",
        statistic: "hiveon_Antminer_T19",
      },
      {
        title: "Antminer S19J",
        link: "firmware/SD_Antminer_S19J_xilinx_19_Hiveon_1_00@220716_MSK_1_3_1_alfacore.zip",
        statistic: "hiveon_Antminer_S19J",
      },
      {
        title: "Antminer S19J PRO",
        link: "firmware/SD_Antminer_S19JPRO_xilinx_19_Hiveon_1_00@220716_MSK_1_3_1_alfacore.zip",
        statistic: "hiveon_Antminer_S19J_PRO",
      },
      {
        title: "Antminer S19 PRO",
        link: "firmware/SD_Antminer_S19PRO_xilinx_19_Hiveon_1_00@220716_MSK_1_3_1_alfacore.zip",
        statistic: "hiveon_Antminer_S19_PRO",
      },
    ],
  },
  seventeenth: {
    heading: "ПРОШИВКИ ДЛЯ 17 й серии BITMAIN",
    instructionHeading:
      "ИНСТРУКЦИЯ После того как вы скачали нужную прошивку нужно:",
    statisticKey: "img",
    firmware: [
      {
        title: "Antminer S17 +",
        link: "firmware/Antminer-S17plus_1.0.8_SD.tar.gz",
        statistic: "img_Antminer_S17_+",
      },
      {
        title: "Antminer T17 +",
        link: "firmware/Antminer-T17plus_1.0.8_SD.tar.gz",
        statistic: "img_Antminer_T17_+",
      },
      {
        title: "Antminer S17 E",
        link: "firmware/Antminer-S17E_1.0.8_SD.tar.gz",
        statistic: "img_Antminer_S17_E",
      },
      {
        title: "Antminer T17 E",
        link: "firmware/Antminer-T17E_1.0.8_SD.tar",
        statistic: "img_Antminer_T17_E",
      },
      {
        title: "Antminer S17",
        link: "firmware/Antminer-S17_1.0.8_SD.tar.gz",
        statistic: "img_Antminer_S17",
      },
      {
        title: "Antminer T17",
        link: "firmware/Antminer-T17_1.0.8_SD.tar.gz",
        statistic: "img_Antminer_T17",
      },
    ],
    instruction: [
      "Содержимое этого архива скопировать на карту памяти (не сам архив, то что внутри его скопировать на чистую карту памяти).",
      "Вставить карту в выключенный асик.",
      "Включить асик, дождаться пока замигают одновременно красный и зеленый диоды.",
      "Выключить асик вытащить карту.",
      "Включить асик и майнить, вписать заново настройки.",
    ],
  },
  vnish: {
    heading:
      "Прошивки VNISH обладают более нестандартным интерфейсом, широким функционалом настроек и плавным запуском асика. Если ваш асик не работает или глючит на обычной прошивке, есть смысл попробовать поставить на него VNISH предварительно разлочим с помощью прошивки MSK MINER путем перепрошивки с карты памяти",
    headingB: "*шьются через веб интерфейс",
    statisticKey: "vnish",
    firmware: [
      {
        title: "Antminer S17",
        link: "firmware/Antminer-S17-2.0.3-vnish_alfacore.tar.gz",
        statistic: "vnish_Antminer_S17",
      },
      {
        title: "Antminer T17",
        link: "firmware/Antminer-T17-2.0.3-vnish_alfacore.tar.gz",
        statistic: "vnish_Antminer_T17",
      },
    ],
  },
  custom: {
    heading:
      "Прошивка для L3+ позволяет разогнать асик до 580 мн (как у L3++) и более при этом существенно снизить его энергопотребление.",
    headingB:
      "*шьется через веб интерфейс. Если не хочет шиться (пишет Cannot find Signature) сначала прошейте анлокером",
    headingC:
      "*после прошивки вылезет ошибка, обновите страницу и шейте снова прошивкой. После этого следайте ребут (Вкладка SYSTEM - REBOOT) Асик перепрошился, если во вкладке SYSTEM L3+ изменится на L3+ (024)",
    statisticKey: "custom",
    firmware: [
      {
        title: "Прошивка для L3+",
        link: "firmware/Antminer-L3+v024-alfacore13-3.tar.gz",
        statistic: "custom_L3+",
      },
    ],
    firmwareB: [
      {
        title: "Unlocker",
        link: getLinkToServerElement("remsig_l3p.tar.gz", "firmware"),
      },
    ],
  },
  tar: {
    heading:
      "А это - прошивки в формате .TAR .GZ (для того, чтобы перепрошивать через веб интерфейс)",
    statisticKey: "tar",
    firmwareA: [
      {
        title: "Antminer S17 +",
        link: "firmware/Antminer-S17plus_1.0.8_SD.tar.gz",
        statistic: "tar_Antminer_S17_+",
      },
      {
        title: "Antminer T17 +",
        link: "firmware/Antminer-T17plus_1.0.8_SD.tar.gz",
        statistic: "tar_Antminer_T17_+",
      },
      {
        title: "Antminer S17 E",
        link: "firmware/Antminer-S17E_1.0.8_SD.tar.gz",
        statistic: "tar_Antminer_S17_E",
      },
      {
        title: "Antminer T17 E",
        link: "firmware/Antminer-T17E_1.0.8_SD.tar",
        statistic: "tar_Antminer_T17_E",
      },
      {
        title: "Antminer S17",
        link: "firmware/Antminer-S17_1.0.8_SD.tar.gz",
        statistic: "tar_Antminer_S17",
      },
      {
        title: "Antminer T17",
        link: "firmware/Antminer-T17_1.0.8_SD.tar.gz",
        statistic: "tar_Antminer_T17",
      },
      {
        title: "Bitmain S9K",
        link: "firmware/Antminer-S9k-v1.0.7.tar.gz",
        statistic: "tar_Bitmain_S9K",
      },
      {
        title: "Bitmain S9SE",
        link: "firmware/Antminer-S9SE-v1.0.7.tar.gz",
        statistic: "tar_Bitmain_S9SE",
      },
      {
        title: "Bitmain S15",
        link: "firmware/Antminer-S15-v1.0.7.tar.gz",
        statistic: "tar_Bitmain_S15",
      },
      {
        title: "Antminer S9 S9i S9j",
        link: "firmware/!!Antminer-S9(i,j)Pro_v5.1_v25_1200W.tar",
        statistic: "tar_Antminer_S9_S9i_S9j",
      },
    ],
    firmwareB: [
      {
        title: "S9 без автотюна VNISH",
        link: "firmware/Antminer-S9-xilinx-vnish-3.8.6-vnish.tar.gz",
        statistic: "tar_Antminer_S9_xilinx",
      },
      {
        title: "Прошивка для сдвоенного S9",
        link: "firmware/Antminer-S9D-xilinx-vnish-3.8.6-vnish.tar.gz",
        statistic: "tar_Antminer_S9D_xilinx",
      },
    ],
  },
};
